// extracted by mini-css-extract-plugin
export default {"siriusTabs":"tabs-module--siriusTabs--CPpPq","white":"tabs-module--white--0i7+s","gray":"tabs-module--gray--zwYwL"};